import styled from 'styled-components'

import copy from 'copy.json'
import { formatDate } from 'utils'
import Button from 'components/Button'
import Status from 'components/Status'
import StyledModal from 'components/layout/StyledModal'

type StatusHistoryAllStatuses = {
  status:
    | 'ACTIVE'
    | 'INACTIVE'
    | 'RESERVED'
    | 'BLOCKED'
    | 'ACCEPTED'
    | 'FINALIZED'
    | 'DELETED'
    | 'CLOSED'
  reason: string
  created_date: string
  modified_by: string
}

type Props = {
  statusHistory: StatusHistoryAllStatuses[]
  isModalOpen: boolean
  onModalClose: () => void
  closeButtonLabel: string
}

export default function StatusHistoryModal({
  statusHistory,
  isModalOpen,
  onModalClose,
  closeButtonLabel
}: Props) {
  const text = copy.buyer.demand_details.modal.status_history

  return (
    <StyledModal isOpen={isModalOpen} onClose={onModalClose}>
      <h3>{text.title}</h3>

      {statusHistory?.map(({ status, created_date, modified_by, reason }) => (
        <Statuses key={created_date}>
          <Status statusType={status} />
          <StatusDetails>
            <Details>
              <p>{text.created_date}</p>
              <p>{formatDate(created_date)}</p>
            </Details>

            <Details>
              <p>{text.modified_by}</p>
              <p>{modified_by}</p>
            </Details>

            {reason && (
              <Details>
                <p>{text.reason}</p>
                <p>{reason}</p>
              </Details>
            )}
          </StatusDetails>
        </Statuses>
      ))}

      <Button onClick={onModalClose} style={{ width: '100%', maxWidth: 424 }}>
        {closeButtonLabel}
      </Button>
    </StyledModal>
  )
}

const Statuses = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 100%;

  span:first-child {
    align-self: flex-start;
    padding: 0px max(8px, calc((100% - 600px) / 2));
  }
`

const StatusDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  padding: 16px 24px;
  padding: 16px max(8px, calc((100% - 600px) / 2));

  background: var(--very-light-blue);
`

const Details = styled.div`
  display: flex;
  gap: 20px;

  font: var(--400-13);

  p:first-of-type {
    width: 90px;
    text-align: left;
    font: var(--600-13);
  }
`
